module.exports = __webpack_public_path__ + "img/brasaoSespa.0047a21b.svg";